<template>
    <v-container class="fill-height" fluid>
        <v-flex style="padding-top: 90px">
            <v-layout row justify-center>
                <v-flex xs12 sm8 md6 lg4 xl3  class="pa-10">
                    <v-card class="elevation-4 pa-8 pt-0 mx-auto">
                        <v-form ref="form" @submit.prevent="login">
                            <v-card-text>
                                <v-card width="150" height="150" class="pa-8 mx-auto round-card" color="#FEC74E">
                                    <v-layout justify-center>
                                        <v-img src="../assets/logo.png" max-width="100" max-height="100">
                                        </v-img>
                                    </v-layout>
                                </v-card>
                                <v-flex>
                                    <div class="headline text-center pa-4 font-weight-black primary--text">MASUK</div>
                                    
                                    <v-text-field
                                    label="Username"
                                    name="username"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    v-model="user.username"
                                    :rules="[v => !!v || 'Username wajib diisi']"
                                    ></v-text-field>

                                    <v-text-field
                                    id="password"
                                    label="Password"
                                    name="password"
                                    prepend-icon="mdi-lock"                                        
                                    :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
                                    :type="show ? 'text' : 'password'"
                                    @click:append="show = !show"
                                    v-model="user.password"
                                    :rules="[v => !!v || 'Password wajib diisi']"
                                    ></v-text-field>
                                    <v-layout justify-end wrap>
                                        <v-btn text x-small class="text-none font-weight-bold text-center" color="primary" to="forgot-password">Lupa Password?</v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-card-text>
                            <v-card-actions>
                                <v-layout justify-center wrap>
                                    <v-btn 
                                        type="submit" 
                                        block 
                                        rounded 
                                        color="primary" 
                                        class="font-weight-bold" 
                                        :disabled="loading" 
                                        :loading="loading" 
                                        x-large
                                    >
                                        <v-icon left>mdi-login</v-icon>
                                        Masuk
                                    </v-btn>
                                    
                                    <div class="ma-7 mb-0 light-grey--text caption text-center">
                                        Tidak mempunyai akun?
                                        <v-btn text x-small class="text-none font-weight-bold text-center" color="primary" to="/register">
                                            Daftar disini
                                        </v-btn>
                                    </div>
                                </v-layout>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                    <v-layout row class="lighter-grey--text caption font-weight-thin text-center mt-10" justify-center>
                        Copyright {{ new Date().getFullYear() }} © Grafindo Media Pratama. All Right Reserved.
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-dialog v-model="showModal" max-width="400" persistent>
            <v-card>
                <v-card-title class="headline">
                    Multiple Log In
                </v-card-title>
                <v-card-text class="pt-4">
                    <p>{{forceLogoutMessage}}</p>
                    <p class="mb-0"><strong>Lanjutkan?</strong></p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelForceLogin">
                        Tidak
                    </v-btn>
                    <v-btn 
                        color="orange" 
                        text
                        @click="confirmForceLogin" 
                        :loading="forceLoginLoading"
                        :disabled="forceLoginLoading"
                    >
                        Ya
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    computed: {
        showForceLogoutDialog() {
            return this.$store.state.status === 'force_logout_required' && this.$store.state.forceLogoutData
        },
        forceLogoutMessage() {
            const forceLogoutData = this.$store.state.forceLogoutData
            if (!forceLogoutData) {
                return 'Akun kamu teraktivasi di perangkat lain. Aktivasi pada perangkat ini mengakibatkan perangkat sebelumnya tidak bisa mengakses layanan ini.'
            }
            // Menggunakan pesan dari API jika ada, jika tidak, gunakan default
            return forceLogoutData.message || 
                   'Akun kamu teraktivasi di perangkat lain. Aktivasi pada perangkat ini mengakibatkan perangkat sebelumnya tidak bisa mengakses layanan ini.'
        },
        showModal: {
            // ✅ MODIFIED: Control modal visibility based on the Vuex state
            get() {
                return this.showForceLogoutDialog
            },
            // Setter untuk menangani penutupan dialog jika diperlukan
            set(value) {
                if (!value) {
                    this.cancelForceLogin()
                }
            }
        }
    },
    
    data: () => ({
        loading: false,
        forceLoginLoading: false,
        user: {},
        message: '',
        error: false,
        show: false
    }),
    
    methods: {
        async login() {
            if (!this.$refs.form.validate()) return
            this.loading = true
            this.error = false
            
            try {
                await this.$store.dispatch('login', this.user)
                
                if (this.$store.getters.isLoggedIn) {
                    this.$store.commit('SHOW_SNACKBAR', { text: 'Login berhasil! Selamat datang.', color: 'success' })
                    this.$router.push('/')
                } else if (this.$store.state.status === 'force_logout_required') {
                    // Modal akan muncul secara otomatis via computed property 'showModal'
                } else {
                    this.error = true
                    this.message = this.$store.state.message || 'Username atau password salah'
                    this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'error' })
                }
            } catch (error) {
                this.error = true
                this.message = 'Terjadi kesalahan sistem'
                this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'error' })
            }
            
            this.loading = false
        },
        
        async confirmForceLogin() {
            this.forceLoginLoading = true
            
            try {
                await this.$store.dispatch('forceLogin', this.user)
                
                if (this.$store.getters.isLoggedIn) {
                    this.$store.commit('SHOW_SNACKBAR', { text: 'Login berhasil! Selamat datang.', color: 'success' })
                    this.$router.push('/')
                } else {
                    this.error = true
                    this.message = this.$store.state.message || 'Force login gagal'
                    this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'error' })
                    // Tutup modal setelah gagal
                    this.$store.commit('CLEAR_FORCE_LOGOUT_CONFIRMATION')
                }
            } catch (error) {
                this.error = true
                this.message = 'Terjadi kesalahan sistem'
                this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'error' })
                // Tutup modal setelah gagal
                this.$store.commit('CLEAR_FORCE_LOGOUT_CONFIRMATION')
            }
            
            this.forceLoginLoading = false
        },
        
        cancelForceLogin() {
            this.$store.commit('CLEAR_FORCE_LOGOUT_CONFIRMATION')
            this.error = false
            this.message = ''
        }
    }
}
</script>

<style>
    .round-card{
        border-radius: 100px !important;
        margin-top: -90px;
    }
</style>